import { Column, Hooks, usePagination, useRowSelect, useSortBy } from 'react-table';
import RowSelectCheckbox from './RowSelectCheckbox';

export type ConfigureTablePluginOptions = {
  hasPagination?: boolean;
  hasRowSelect?: boolean;
  initialSortBy?: Array<{ id: string; desc: boolean }>;
};

export default function configureTable<D extends {}>(columns: Column<D>[], data: D[], options: ConfigureTablePluginOptions = {}) {
  return {
    tableOptions: {
      columns,
      data,
      initialState: {
        sortBy: options.initialSortBy ?? [],
      },
    },
    tablePlugins: [
      useSortBy,
      ...(options.hasPagination ? configurePagination() : []),
      ...(options.hasRowSelect ? configureRowSelect() : []),
    ],
  };
}

function configurePagination() {
  return [usePagination];
}

function configureRowSelect() {
  return [
    useRowSelect,
    (hooks: Hooks) => {
      hooks.visibleColumns.push(cols => [
        {
          id: 'selection',
          Header: ({ getToggleAllRowsSelectedProps }) => {
            return <RowSelectCheckbox {...getToggleAllRowsSelectedProps()} />;
          },
          Cell: ({ row }) => <RowSelectCheckbox {...row.getToggleRowSelectedProps()} />,
        },
        ...cols,
      ]);
    },
  ];
}
